import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { getFtpList } from "./actions";

export const ftpListEntityAdapter = createEntityAdapter({
  selectId: (entity) => entity._id,
});

const initialState = ftpListEntityAdapter.getInitialState({});

export const ftpListSlice = createSlice({
  name: "ftpList",
  initialState: initialState,
  reducers: {
    clearFtpList: (state) => {
      ftpListEntityAdapter.removeAll(state);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getFtpList.fulfilled, (state, action) => {
      if (action.payload && action.payload.status && action.payload.data) {
        const append = action.meta?.arg?.append || false;

        if (append) {
          // Append/update entities to existing state
          ftpListEntityAdapter.setMany(state, action.payload.data);
        } else {
          // Replace all entities (clear and set)
          ftpListEntityAdapter.setAll(state, action.payload.data);
        }
      }
    });
  },
});

export const { clearFtpList } = ftpListSlice.actions;

export default ftpListSlice.reducer;
